import { render, staticRenderFns } from "./SidebarOndemand.vue?vue&type=template&id=1c0ab2ec&scoped=true"
import script from "./SidebarOndemand.vue?vue&type=script&lang=js"
export * from "./SidebarOndemand.vue?vue&type=script&lang=js"
import style0 from "./SidebarOndemand.vue?vue&type=style&index=0&id=1c0ab2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ab2ec",
  null
  
)

export default component.exports